import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { CheckHealth } from '../../redux/constants/apiConstants';
import Waiting from '../Waiting';
import LazyImage from '../common/LazyImage/LazyImage';
import { ImageUrl } from '../../utils/constants';
import history from '../../utils/history';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  ${'' /* max-width: 520px; */}
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Title = styled.h1`
  color: #184a61;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: clamp(22px, 4vw, 32px);
  line-height: 1.2;
  margin-bottom: 16px;
`;

const Description = styled.div`
  color: #184a61;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: clamp(14px, 3.5vw, 18px);
  line-height: 1.4;
  margin-bottom: 32px;
  max-width: 308px;
`;

const ImageWrapper = styled.div`
  ${'' /* width: 100%; */}
  ${'' /* max-width: 920px; */}

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const MaintenancePage = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getServerHealth();
  }, []);

  const getServerHealth = async () => {
    setLoading(true);
    try {
      const res = await fetchApi(CheckHealth, 'GET');
      if (res?.status === "success") { 
        history.push("/portal"); 
      } else { setErrorMessage(res?.data?.message) }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Waiting />;

  return (
    <Wrapper>
      <Card>
        <Title>{errorMessage || 'Site Under Maintenance'}</Title>

        <Description>
          We’re working behind the scenes to serve you better.
        </Description>

        <ImageWrapper>
          <LazyImage
            src={`${ImageUrl}/images/maintenance-page/maintenance.svg`}
            alt="Maintenance"
          />
        </ImageWrapper>
      </Card>
    </Wrapper>
  );
};

export default MaintenancePage;
